import clsx from 'clsx'
import React, { useEffect } from 'react'

interface Props {
  open: boolean
  children: React.ReactNode
  className?: string
}

export const FullScreenModal = ({ open, children, className }: Props) => {
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
    }
  }, [open])

  if (!open) return null

  const childrenArray = React.Children.toArray(children) as any[]

  // Extract slot-based elements
  const header = childrenArray.find(child => child?.props?.slot === 'header')
  const body = childrenArray.find(child => child?.props?.slot === 'body')
  const actions = childrenArray.find(child => child?.props?.slot === 'actions')

  // Detect if slots are used
  const hasSlots = header || body || actions

  // Fallback: if no slots → treat all children as body
  const fallbackBody = !hasSlots ? children : null

  return (
    <div className="fixed inset-0 z-[9999]">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Modal Container */}
      <div
        role="dialog"
        className={clsx(
          'relative w-full h-[90%] max-w-[1330px] mx-auto top-1/2 -translate-y-1/2 flex flex-col bg-white rounded-2xl overflow-hidden',
          className,
        )}
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          {header && <div className="flex items-center justify-between p-4">{header}</div>}

          {/* Body */}
          <div className="flex-1 overflow-auto">{body || fallbackBody}</div>

          {/* Actions / Footer */}
          {actions && <div className="p-4">{actions}</div>}
        </div>
      </div>
    </div>
  )
}
